<template>
  <main class="flex-row">
    <beansid-landing-page
      :slug="brand"
      :territory
      width="100%"
    />
  </main>
</template>

<script lang="ts" setup>
const { $feature } = useNuxtApp()
const locale = useLocale()
const iframeUrl = $feature.configStudentDiscount?.iframe_url
const vendorList = Array.isArray(iframeUrl) ? iframeUrl : iframeUrl?.[locale]
const src = vendorList?.find((entry: { vendor: string }) => entry.vendor === 'studentbeans')?.url ?? ''

if (!src)
  throw createError({ statusCode: 404, fatal: true })

const { brand } = useRuntimeConfig().public
const countryCode = useCountryCode()
const territory = countryCode === 'GB' ? 'uk' : countryCode.toLowerCase()

useScript({
  async: true,
  src,
  id: 'beansid-script'
})
</script>
